import axios from "axios";
import React, { useEffect, useState } from "react";
import LoadingScreen from "./../LoadingScreen/LoadingScreen";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet";

export default function Categories() {
  const baseURL = "https://ecommerce.routemisr.com"; // or 'https://route-ecommerce-app.vercel.app'
  const [Categories, setCategories] = useState(null);

  async function getCategories(page) {
    let { data } = await axios.get(`${baseURL}/api/v1/categories`, {
      params: { limit: 12, page: page },
    });
    setCategories(data.data);
  }

  useEffect(() => {
    getCategories();
  });
  return (
    <>
      <Helmet>
        <meta charSet="utf-8" />
        <title>Fresh Cart Categories</title>
      </Helmet>

      {/* display loading screen till fetching data */}

      {Categories ? (
        <div className="row my-5 align-items-center">
          <div className="col-md-3">
            <div className="intro ">
              <h2 className=" fw-bolder fs-1 text-main">Our Categories</h2>

              <p className=" text-text-muted font-sm ">
                You can see our Categories and each Category products{" "}
              </p>
            </div>
          </div>

          {/* display all categories */}

          {Categories.map((category, idx) => (
            <div key={idx} className="col-md-3">
              <div className="product cursor-pointer px-2 py-3">
                {/* link to get products of specific category */}

                <Link to={`/categorydetails/${category._id}`}>
                  {/* display category img  */}
                  <img
                    className="w-100"
                    height={300}
                    src={category.image}
                    alt={category.name}
                  />

                  {/* display category name */}
                  <h2 className=" fw-bold h6 text-center text-main">
                    {category.name}
                  </h2>
                </Link>
              </div>
            </div>
          ))}
        </div>
      ) : (
        <LoadingScreen />
      )}
    </>
  );
}
